module.exports = __webpack_public_path__ + "static/img/r-2-3.af7724e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/r-2-3.png
// module id = i7Ua
// module chunks = 0